import BaseChangeset from 'common/changesets/base';

export type ContactFormDTO = {
  type: string;
  name: string;
  email: string;
  phone: string;
  message: string;
};

export class ContactFormChangeset extends BaseChangeset<ContactFormDTO> {}
